import React from 'react';

type BadgeTone = 'neutral' | 'ok' | 'warn' | 'danger' | 'info' | 'forest' | 'teal' | 'coral';

const toneStyles: Record<BadgeTone, string> = {
  neutral: 'bg-ink-100 text-ink-700 border-ink-200',
  ok:      'bg-ok-50 text-ok-700 border-green-200',
  warn:    'bg-warn-50 text-warn-700 border-yellow-200',
  danger:  'bg-danger-50 text-danger-700 border-red-200',
  info:    'bg-info-50 text-info-700 border-blue-200',
  forest:  'bg-forest-50 text-forest-900 border-forest-200',
  teal:    'bg-teal-50 text-teal-800 border-teal-200',
  coral:   'bg-coral-50 text-coral-700 border-coral-200',
};

const dotColors: Record<BadgeTone, string> = {
  neutral: 'bg-ink-500',
  ok:      'bg-ok-500',
  warn:    'bg-warn-500',
  danger:  'bg-danger-500',
  info:    'bg-info-500',
  forest:  'bg-forest-900',
  teal:    'bg-teal-400',
  coral:   'bg-coral-400',
};

interface BadgeProps {
  tone?: BadgeTone;
  dot?: boolean;
  size?: 'sm' | 'md';
  children: React.ReactNode;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ tone = 'neutral', dot = false, size = 'md', children, className = '' }) => {
  const sizeClass = size === 'sm' ? 'text-[11px] px-1.5 py-0.5' : 'text-[12px] px-2 py-0.5';
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border font-medium leading-none ${sizeClass} ${toneStyles[tone]} ${className}`}>
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${dotColors[tone]}`} />}
      {children}
    </span>
  );
};

export default Badge;
